import { render, staticRenderFns } from "./phones.vue?vue&type=template&id=2d66f38e&"
import script from "./phones.vue?vue&type=script&lang=ts&"
export * from "./phones.vue?vue&type=script&lang=ts&"
import style0 from "./phones.vue?vue&type=style&index=0&id=2d66f38e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports